/// <reference path="event-tracking.js" />
/// <summary>
/// Google tracking events for the PDP page
/// </summary>
(function ($) {
    evo.tracking.setCategory('PDP-Interactions');
    evo.tracking.setActions({
        'bc': 'Breadcrumbs',
        'ql': 'Quicklink',
        'rv': 'RecentlyViewed',
        'aiv': 'AltImageVideo',
        'bga': 'BuyGrid-AddToCart',
        'bge': 'BuyGrid-Error',
        'bgs': 'BuyGrid-SocialLinks',
        'sab': 'ShopAllBrandsClick',
        'spb': 'SuggestedProducts-BuyAsPackage',
        'spp': 'SuggestedProducts-PurchasedCompatible',
        'spr': 'SuggestedProducts-Related',
        'sps': 'SuggestedProducts-Similar',
        'acmb': 'AddToCartModal-Button',
        'acms': 'AddToCartModal-Suggested'
    });

    $(function () {
        evo.$.body.on('loaded.evo.pdp.interstitial', function (e, modal) {
            evo.tracking.bindTracking(modal);
        });
        evo.$.body.on('error.evo.pdp.addtocart', function (e, message) {
            evo.tracking.track('PDP-Interactions', 'bge', message);
        });
        evo.$.body.on('added.evo.pdp.addtocart', function (e, childsku) {
            evo.tracking.track('PDP-Interactions', 'bga', childsku);
        });
        // Bind the product thumb click events to push to the Google dataLayer.
        evo.$.body.on("click", ".js-product-thumb-link, .js-product-thumb-details-link", function () {
            var productPageId = $(this).data("unique-id");

            window.dataLayerManager.pushProductClick(productPageId, "Results");
        });
    });
})(jQuery);